import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CoconutTree, Fish, Beach, FishingBoat, Hibiscus, Seashell } from "@/components/KonkanVectors";

const V = ({ children, className }) => (
  <div className={`absolute pointer-events-none select-none ${className}`} aria-hidden="true">{children}</div>
);

export const BottomCTA = () => (
  <section className="relative py-10 md:py-14 px-6 md:px-8 bg-white overflow-hidden" data-testid="cta-section">
    <V className="-left-4 md:left-0 -bottom-4 w-36 md:w-56 opacity-[0.18]"><CoconutTree /></V>
    <V className="right-2 md:right-8 top-2 w-20 md:w-32 opacity-[0.18]"><Fish /></V>
    <V className="right-1/3 bottom-0 w-32 md:w-48 opacity-[0.10]"><Beach /></V>
    <div className="max-w-7xl mx-auto relative z-10 grid grid-cols-1 md:grid-cols-2 gap-5">
      {/* Own a Homestay */}
      <div className="relative rounded-2xl overflow-hidden min-h-[220px] flex items-end" data-testid="cta-own-homestay">
        <div className="absolute inset-0 bg-gradient-to-br from-[#2F5D3A]/90 via-[#2F5D3A]/80 to-[#5B7F4A]/70" />
        <V className="absolute right-0 bottom-0 w-40 opacity-[0.15]"><FishingBoat /></V>
        <div className="relative z-10 p-6 md:p-8">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-2">Own a Homestay?</h3>
          <p className="text-sm text-white/80 mb-5 max-w-sm">
            Earn with Kokan Homestays by hosting travellers from around the world.
          </p>
          <Link to="/list-your-homestay">
            <Button className="bg-white text-[#2F5D3A] hover:bg-white/90 rounded-full px-6 py-2.5 text-sm font-semibold shadow-md">
              List Your Homestay
            </Button>
          </Link>
        </div>
      </div>

      {/* Newsletter */}
      <div className="relative rounded-2xl overflow-hidden bg-[#FAF8F3] border border-border/30 min-h-[220px] flex items-end" data-testid="cta-newsletter">
        <V className="absolute -right-4 -top-2 w-20 opacity-[0.15]"><Hibiscus /></V>
        <V className="absolute left-4 -bottom-2 w-16 opacity-[0.12]"><Seashell /></V>
        <div className="relative z-10 p-6 md:p-8 w-full">
          <h3 className="text-xl md:text-2xl font-bold text-foreground mb-2">Get Konkan Travel Ideas</h3>
          <p className="text-sm text-muted-foreground mb-5">
            Stories, travel tips & exclusive offers straight to your inbox.
          </p>
          <form className="flex gap-2 max-w-md" onSubmit={(e) => e.preventDefault()}>
            <Input
              type="email"
              placeholder="Enter your email"
              className="flex-1 rounded-full py-5 px-5 bg-white border-border/50 text-sm"
              data-testid="newsletter-email"
            />
            <Button type="submit" className="bg-[#D88A2B] text-white hover:bg-[#C07A22] rounded-full px-6 text-sm font-semibold whitespace-nowrap" data-testid="newsletter-subscribe-btn">
              Subscribe
            </Button>
          </form>
        </div>
      </div>
    </div>
  </section>
);
